import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { DayPartingInputsComponent } from "@m19-board/strategies/day-parting-inputs/day-parting-inputs.component";
import { Observable } from "rxjs";
import { StrategyEx } from "@front/m19-models";
import { TranslocoDirective } from "@jsverse/transloco";
import { IButtonComponent, MODAL_DATA, ModalRef } from "@front/m19-ui";

@UntilDestroy()
@Component({
  selector: "app-day-parting-pop-up",
  templateUrl: "./day-parting-pop-up.component.html",
  styleUrls: ["./day-parting-pop-up.component.scss"],
  standalone: true,
  imports: [TranslocoDirective, DayPartingInputsComponent, IButtonComponent],
})
export class DayPartingPopUpComponent implements OnInit {
  modalData = inject(MODAL_DATA) as DayPartingPopUpData;
  modalRef = inject(ModalRef);

  strategy: StrategyEx | undefined;

  @ViewChild("dayPartingInputsComponent") dayPartingInputsComponent!: DayPartingInputsComponent;

  ngOnInit(): void {
    if (this.modalData.strategy$) {
      this.modalData.strategy$.pipe(untilDestroyed(this)).subscribe((x) => (this.strategy = x));
    }
  }

  onSave(): void {
    this.dayPartingInputsComponent.pushDayPartingPref();
    this.modalRef.close();
  }
}

export interface DayPartingPopUpData {
  strategy$?: Observable<StrategyEx | undefined>;
  currencyCode: string;
  locale: string;
  dayPartingPauseHour?: number;
  dayPartingReactivationHour?: number;
}
